<template>
  <v-navigation-drawer
      app
      clipped
      right
      v-model="PROFILE_SETTINGS_DRAWER_STATE"
      :mini-variant="isMini"
      permanent
      mini-variant-width="50"
      :class="{'drawer-mini': !PROFILE_SETTINGS_DRAWER_STATE}"
      class="mt-15 pb-15 mt-md-16 pb-md-16"
      width="400"
  >
    <div v-show="!isMini">
      <v-btn class="pa-5" icon @click.stop="TOGGLE_PROFILE_SETTINGS_DRAWER">
        <v-icon color="primary">close</v-icon>
      </v-btn>
    </div>
    <div v-show="isMini" class="text-center">
      <v-btn class="pa-5" icon @click.stop="TOGGLE_PROFILE_SETTINGS_DRAWER">
        <v-icon color="primary">link</v-icon>
      </v-btn>
    </div>

    <v-divider></v-divider>

    <!-- Facility info link -->
    <div v-show="!isMini">
      <v-btn
          block
          tile
          text
          class="btn-as-expansion"
          @click="pushToUser()"
      >
        <v-icon>elevator</v-icon>
        <span class="green-dot ml-1"></span>
        <span :class="($route.path === '/' + this.$store.state.manager.settingsModuleUrl + '/profile/user') ? 'btn-expnsion-text--active ml-2' : 'btn-expansion-text ml-2'">
          {{ $t(this.$store.state.manager.settingsModuleUrl + '/profile:quicklink-sidebar.profile-settings') }}
        </span>
        <v-spacer></v-spacer>
        <v-icon>edit</v-icon>
      </v-btn>
    </div>

    <v-divider v-show="!isMini"></v-divider>

    <v-expansion-panels v-show="!isMini && isMain" tile accordion class="expansion-panel-items-small">
      <!-- Role expansion panel -->
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row align="center">
            <v-col cols="1"><v-icon>assignment</v-icon></v-col>
            <v-col cols="5">
              <span class="green-dot"></span>
              <span :class="($route.path !== '/' + this.$store.state.manager.settingsModuleUrl + '/profile/user') ? 'active-panel ml-2' : 'ml-2'">{{ $t('settings/profile:quicklink-sidebar.customer.title') }}</span>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
          <v-list>
            <v-list-item-group>
              <v-list-item @click="pushToCustomer()">
                {{ $t('common:settings') }}
              </v-list-item>
              <v-list-item @click="pushToCustomerUsers()">
                <v-row align="center" no-gutters>
                  <v-col>
                    {{ $t('settings/profile:quicklink-sidebar.customer.user-management') }}
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col class="text-right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs}">
                        <v-btn icon class="icon-btn" @click.native.stop="addUser" v-bind="attrs" v-on="on">
                          <v-icon>add</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('buttons:add-specific', { specific: $t('common:user')}) }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item @click="pushToSubCustomers()">
                <v-row align="center" no-gutters>
                  <v-col>
                    {{$t("settings/profile:quicklink-sidebar.customer.sub-customers")}}
                  </v-col>

                  <v-col class="text-right" cols="3">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs}">
                        <v-btn icon class="icon-btn" @click.native.stop="addSubCustomer" v-bind="attrs" v-on="on">
                          <v-icon>add</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('settings/profile:quicklink-sidebar.customer.add-sub-customer') }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <MinimizedCustomerDialogForm ref="customerDialogForm"  sub-customer @onSave="onCustomerAdded"/>
    <UsersDialogForm ref="usersDialogForm" @updateUsers="pushToCustomerUsers"/>
  </v-navigation-drawer>
</template>
<script>

import UsersDialogForm from './UsersDialogForm'
import MinimizedCustomerDialogForm from "@/modules/core/components/MinimizedCustomerDialogForm.vue";
import {mapActions, mapState, mapGetters} from 'vuex'


export default {
  name: 'ProfileQuickLinkSidebar',
  components: {
    UsersDialogForm,
    MinimizedCustomerDialogForm
  },
  data() {
    return {
      usersTable: {
        options: [],
        search: []
      }
    }
  },
  computed: {
    ...mapState('settings/layout', {
      profileSettingsDrawer: state => state.profileSettingsDrawer
    }),
    PROFILE_SETTINGS_DRAWER_STATE: {
      get() {
        return this.profileSettingsDrawer
      },
      set(newValue) {
        if (newValue === this.profileSettingsDrawer) return;
        this.TOGGLE_PROFILE_SETTINGS_DRAWER();
      }
    },
    isMini() {
      // if screen size is md or lower
      if(this.$vuetify.breakpoint.mdAndDown) {
        return this.PROFILE_SETTINGS_DRAWER_STATE
      } else {
        return !this.PROFILE_SETTINGS_DRAWER_STATE
      }
    },
    ...mapGetters('auth', ['isMain']),
  },
  methods: {
    ...mapActions(
        'settings/layout', ['TOGGLE_PROFILE_SETTINGS_DRAWER']
    ),
    pushToUser() {
      if(this.$route.path !== '/' + this.$store.state.manager.settingsModuleUrl + '/profile/user') {
        this.$router.push('/' + this.$store.state.manager.settingsModuleUrl + '/profile/user')
      }
    },
    pushToCustomer() {
      if(this.$route.path !== '/' + this.$store.state.manager.settingsModuleUrl + '/profile/customer/profile') {
        this.$router.push('/' + this.$store.state.manager.settingsModuleUrl + '/profile/customer/profile')
      }
    },
    addUser() {
      if(this.$route.path !== '/' + this.$store.state.manager.settingsModuleUrl + '/profile/customer/users') {
        this.$refs.usersDialogForm.addUser()
      } else {
        this.$emit('addUser');
      }
    },
    addSubCustomer() {
      this.$refs.customerDialogForm.openAddDialog();
    },
    onCustomerAdded() {
      if(this.$route.path === '/' + this.$store.state.manager.settingsModuleUrl + '/profile/customer/sub-customers') {
        this.$emit('refreshRouter');
      }
    },
    pushToCustomerUsers() {
      // if current route is different to the page where the users datatable is
      if(this.$route.path !== '/' + this.$store.state.manager.settingsModuleUrl + '/profile/customer/users') {
        // route to users datatable page to refresh data
        this.$router.push('/' + this.$store.state.manager.settingsModuleUrl + '/profile/customer/users')
      }
    },
    pushToSubCustomers() {
      // if current route is different to the page where the users datatable is
      if(this.$route.path !== '/' + this.$store.state.manager.settingsModuleUrl + '/profile/customer/sub-customers') {
        // route to users datatable page to refresh data
        this.$router.push('/' + this.$store.state.manager.settingsModuleUrl + '/profile/customer/sub-customers')
      }
    }
  },

}
</script>
<style lang="scss">
  .btn-as-expansion {
    justify-content: start;
    height: 52px!important;

    .v-icon {
      color: rgba(0, 0, 0, 0.54)!important;
    }

    .btn-expansion-text {
      color: rgba(0, 0, 0, 0.87);
      font-size: 0.9375rem;
      line-height: 1;
      text-transform: capitalize;
      letter-spacing: normal;
    }
    .btn-expnsion-text--active {
      color: var(--v-primary-base)!important;
      font-size: 0.9375rem;
      line-height: 1;
      text-transform: capitalize;
      letter-spacing: normal;
      font-weight: bold;
    }
  }
  .icon-btn {
    color: white!important;
    background-color: var(--v-primary-base)!important;
  }
  .active-panel {
    color: var(--v-primary-base)!important;
    font-weight: bold;
  }
</style>
